module.exports = __webpack_public_path__ + "img/img (33).b632662f.jpg";